import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const PaymentStatusPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

    useEffect(() => {
      const params = new URLSearchParams(location.search);
      const status = params.get('redirect_status');

      if (status === 'succeeded') {
        navigate('/view');
      } else {
        navigate(`/payment?error=${status || 'unknown'}`);
      }
    }, [location, navigate]);

  return null; // No UI shown here
};

export default PaymentStatusPage;
